<div class="settingsDisplay t-{{activeTheme.theme}}-dialog">
  <mat-toolbar class="settingsToolbar" color="primary">
    <p style="flex-grow: 1">{{ 'SETTINGS' | translate }}: {{terminalName}}</p>
    <button mat-button (click)="dialogRef.close()">
      <i class="material-icons">close</i>
    </button>
  </mat-toolbar>
  <div class="settingsContent">
    <ul>
      <li>
        <mat-slide-toggle [checked]="settings.ciCoDetails" (change)="onChangeDetails()">
          {{ "SHOW_WORKERS" | translate }}
        </mat-slide-toggle>
      </li>
      <li class="subMenu" [@showSubMenu]="settings.ciCoDetails ? 'show' : 'hide'">
        <ul>
          <li>
            <mat-form-field style="width: 80%; margin-left: 44px">
              <mat-label>{{ "WORKER_COLUMN_COUNT" | translate }}</mat-label>
              <mat-select [(value)]="settings.columnCount" (selectionChange)="onChangeDynamicGrid()">
                <mat-option *ngFor="let count of [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]" [value]="count">{{count}}</mat-option>
              </mat-select>
            </mat-form-field>
          </li>
          <li>
            <mat-checkbox [checked]="settings.littleMessageBlock" (change)="onChangeLittleMessageBlock()">
              {{ "LITTLE_MESSAGE_BLOCK" | translate }}
            </mat-checkbox>
          </li>
          <li>
            <mat-checkbox [checked]="settings.showImages" (change)="onChangeShowImages()">
              {{ "WORKER_IMAGES" | translate }}
            </mat-checkbox>
          </li>
          <li>
            <mat-checkbox [checked]="settings.showAbsent" [disabled]="!appService.getInterfaceAttendanceDetailed()" (change)="onChangeShowAbsent()">
              {{ "WORKER_SHOW_ABSENT" | translate }}
            </mat-checkbox>
          </li>
          <li>
            <mat-form-field style="width: 80%; margin-left: 44px">
              <mat-label>{{ "WORKER_FILTER" | translate }}</mat-label>
              <mat-select [(value)]="settings.workerFilter" [disabled]="!appService.getInterfaceAttendanceDetailed()" (selectionChange)="onChangeWorkerFilter()">
                <mat-option [value]="workerFilterOption.Default">{{ "WORKER_FILTER_DEFAULT" | translate }}</mat-option>
                <mat-option [value]="workerFilterOption.All">{{ "WORKER_FILTER_ALL" | translate }}</mat-option>
                <mat-option [value]="workerFilterOption.CheckedIn">{{ "WORKER_FILTER_CHECKEDIN" | translate }}</mat-option>
              </mat-select>
              <mat-hint *ngIf="!appService.getInterfaceAttendanceDetailed()">{{ "WORKER_FILTER_DISABLED_HINT" | translate }}</mat-hint>
            </mat-form-field>
          </li>
        </ul>
      </li>
      <li>
        <mat-slide-toggle [checked]="settings.showWorkerBackground" (change)="onChangeShowWorkerBackground()">
          {{ "SHOW_WORKERBACKGROUND" | translate }}
        </mat-slide-toggle>
      </li>
      <li>
        <button mat-flat-button class="settingsButton" color="primary" (click)="openColorPicker()">
          {{ "COLOR_PICKER" | translate }}
        </button>
      </li>
      <li>
        <div class="dataReset">
          <span class="buttonLabel">{{ "FULL_DATA_RESET" | translate }}</span>
          <button mat-button color="primary" (click)="signOut()" matTooltip='{{ "CLEAR_ALL_DATA" | translate }}'>
            <i class="material-icons">delete_forever</i>
          </button>
        </div>
      </li>
    </ul>
  </div>
</div>
